import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["pill"]

  toggle(event) {
    const pillElement = event.currentTarget
    const checkbox = pillElement.querySelector('input[type="checkbox"]')

    // Toggle the checkbox state
    checkbox.checked = !checkbox.checked

    // Update the visual state
    if (checkbox.checked) {
      pillElement.classList.remove('inactive')
      pillElement.classList.add('active')
    } else {
      pillElement.classList.remove('active')
      pillElement.classList.add('inactive')
    }
  }
}
